import {
  CORE_LOAD_LOCATIONS_REQUEST,
  CORE_LOAD_LOCATIONS_SUCCESS

} from '../../../types'

const initialState = []
export default {
  coreLocations: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_LOCATIONS_REQUEST:
        return initialState
      case CORE_LOAD_LOCATIONS_SUCCESS:
        if (action.payload)
          return action.payload
        else return []
      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/settings/location/reducer.js